<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-04-02 10:26:20
 * @LastEditors: xst
 * @LastEditTime: 2020-04-02 10:28:32
 -->
<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
}

</script>

<style lang="scss">
  * {
    touch-action: pan-y;
  }
body {
  width: 100%;height: 100%;position: absolute;margin: 0px;padding: 0px;
	font-family: Microsoft YaHei, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,  SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}
#app {
	position: relative;
	top: 0px;
	bottom: 0px;
	width: 100%;
  height: 100%;
}
a{
  color: #56a9ff;
}
.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
* { touch-action: pan-y; }
</style>



// WEBPACK FOOTER //
// src/App.vue